import { render, staticRenderFns } from "./AverageTime.vue?vue&type=template&id=574796a3"
import script from "./AverageTime.vue?vue&type=script&lang=ts"
export * from "./AverageTime.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports